<template>
  <div>
    <body>
      <RegistrationHeader/>
      <ProgressIndicator  v-if="progress"/>
      <router-view />
      <div class=""></div>
      <DealerInfo  v-if="dealer"/>
      <RegistrationFooter/>

    </body>
  </div>
</template>

<script>
  import RegistrationHeader from '@/components/openMarket/RegistrationHeader'
  import DealerInfo from '@/components/openMarket/DealerInfo'
  import RegistrationFooter from '@/components/openMarket/RegistrationFooter'
  import ProgressIndicator from '@/components/openMarket/ProgressIndicator'

  export default {
    name: 'app',
    data() {
      return {}
    },

    components: {
      RegistrationHeader,
      ProgressIndicator,
      DealerInfo,
      RegistrationFooter,
    },

    mounted() {
      //http://localhost:8080/vue/?formId=71018&agentId=370981&openmktCd=2  
    },

    created() {

    },
    computed: {
      dealer() {
        if(this.$route.name === 'ExistingRegistration' ||
           this.$route.name === 'OpenMarketTerms') {
          return false
        }
        if(this.$store.state.notFoundUrl) {
          return false
        }
        return true
      },

      progress() {
        if(this.$route.name === 'OpenMarket' || 
           this.$route.name === 'Error' ||
           this.$route.name === 'ExistingRegistration' ||
           this.$route.name === 'OpenMarketTerms') {
          return false
        }
        return true
      },
    },

    methods: {


    }

  }
</script>

<style>

</style>
